import React from 'react';
import PropTypes from 'prop-types';
import BaseDetails from './base-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SimpleDetails = _ref => {
  var icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    note = _ref.note,
    approximate = _ref.approximate,
    className = _ref.className;
  return ___EmotionJSX(BaseDetails, {
    label: label,
    icon: icon,
    className: className
  }, value, approximate && ___EmotionJSX("sup", null, "*"), " ", note && "(".concat(note, ")"));
};
SimpleDetails.defaultProps = {
  note: null,
  approximate: false,
  className: null,
  icon: undefined
};
SimpleDetails.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  note: PropTypes.string,
  approximate: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.node
};
export default SimpleDetails;